<div id="sectionElement" class="center animatable reveal">
  <div class="section-info">
    <h2>Our Services</h2>
    <div class="section-description">
      We deliver comprehensive technology solutions designed to transform your business goals into high-performance digital products.
      <!--      We are engaged in outsourcing, helping make ideas real, and our customers can see and enjoy use of product.
            <span class="center">
              Our services span the full range of IT needs, from plan and design to development and maintenance.
            </span>-->
    </div>
  </div>

  <div class="services">
    @for (service of services(); track service.documentId) {
      <div class="container animated-gradient">
        <div class="inner-container">
          <div class="icon-container">
            <img [src]="service.icon.url" height="24">
          </div>
          <div class="title">{{service?.title}}</div>
          <span class="text">
          {{service?.description}}
        </span>
        </div>
      </div>
    }
  </div>
</div>
